import "@preact/signals";
import * as preact from "preact";

import SelectionStore from "stores/SelectionStore";

interface Props {
  model: SelectionStore;
}

class SelectWholeCollectionView extends preact.Component<Props> {
  isVisible() {
    return (
      this.props.model.wholePage.value &&
      this.props.model.getTotalCount() > this.props.model.getPageCount()
    );
  }

  selectAll = (event: Event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.model.selectWholeCollection();
  };

  clearSelection = (event: Event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.model.clearSelection();
  };

  render() {
    const visible = this.isVisible();
    if (!visible) {
      return (
        <div
          class="wordListNotification selectWholeGroup"
          style={{ display: "none" }}
        />
      );
    }

    const wholeCollection = this.props.model.wholeCollection.value;
    const pageCount = this.props.model.getPageCount();
    const totalCount = this.props.model.getTotalCount();

    if (wholeCollection) {
      return (
        <div
          class="wordListNotification selectWholeGroup"
          style={{ display: "block" }}
        >
          All {totalCount} words are selected.{" "}
          <a
            href="#"
            data-action="clearSelection"
            onClick={this.clearSelection}
          >
            Clear Selection
          </a>
        </div>
      );
    }
    return (
      <div
        class="wordListNotification selectWholeGroup"
        style={{ display: "block" }}
      >
        All {pageCount} loaded words are selected.{" "}
        <a href="#" data-action="selectAll" onClick={this.selectAll}>
          Select all {totalCount} words
        </a>
      </div>
    );
  }
}

export default SelectWholeCollectionView;
